import { Typography } from '@affinidi/component-library'
import styled from 'styled-components'

export const LinkStyled = styled(Typography)`
  color: ${(props) => props.theme.colors.brand.primary['100']};
`
